module.exports = __webpack_public_path__ + "static/media/stockhausen_nowald_14.34892e33.jpeg";